import { Map } from 'immutable';
import core from './core';

const INITIAL_STATE = new Map({
    list: new Map(),
    initialized: false,
    historyActions: new Map()
});
export default (env, state = INITIAL_STATE, action) => {
    switch (action.type) {
        case `${env.toUpperCase()}__UPDATE_HOME_PRODUCTS`:
            return core.setHomeProductsInitialized(state, action.homeId);
        case `${env.toUpperCase()}__SET_HOMES`:
            return core.setHomes(state, action.homes);
        case `${env.toUpperCase()}__SET_HISTORY_ACTIONS`:
            return core.setHistoryActions(state, action.historyActions);
        case `${env.toUpperCase()}__UPDATE_HOMES`:
            return core.updateHomes(state, action.homes);
        case `${env.toUpperCase()}__UPDATE_HOME`:
            return core.updateHome(state, action.homeId, action.homeDetails);
        case `${env.toUpperCase()}__UPDATE_HOME_GENERATORS`:
            return core.updateHomeGenerators(state, action.homeId, action.homeGenerators);
        case `${env.toUpperCase()}__DELETE_HOME_GENERATOR`:
            return core.deleteHomeGenerator(state, action.homeId, action.generatorId);
        case `${env.toUpperCase()}__DELETE_HOME`:
            return core.homeDelete(state, action.payload);
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./environments/genericEnv/data/Homes/reducer.js